import StrategyCards from "./container"
import './style.scss'
export default StrategyCards;